import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PopupAttach extends React.Component {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
    this.el.setAttribute('id', 'popup');
    this.el.setAttribute('style', 'position:absolute;height:100%;width:100%; top:0px; right:0; bottom:30px;left:0; z-index:99999; pointer-events:all');
  }

  componentDidMount() {
    // 
    document.querySelector('#popup-container2').appendChild(this.el);
  }

  componentWillUnmount() {
    // 
    document.querySelector('#popup-container2').removeChild(this.el);
  }

  render() {
    
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

PopupAttach.propTypes = {
  children: PropTypes.element,
};

export default PopupAttach;
